
function Footer() {

    return (<div style={{padding : '3px'}}>
        <p> © Etienne PERCHE </p>
    </div>);
}

export default Footer